import styled from 'styled-components';
import GraphOption from './GraphOption';


const GraphOptionsContent = styled.div`
    display: flex;
    text-align: center;
    font-size: 2em;
    color: #404040;
`;


function GraphOptions(props) {
    const teamSubsetOptions = props.teamSubsetOptions;
    const timeScaleOptions = props.timeScaleOptions;
    const yAxisOptions = props.yAxisOptions;
    const seasonOptions = props.seasonOptions;

    const teamSubsetChoice = <GraphOption name={teamSubsetOptions.name} options={teamSubsetOptions.options} selected={teamSubsetOptions.selected} setter={teamSubsetOptions.setter}/>;
    const timeScaleChoice = <GraphOption name={timeScaleOptions.name} options={timeScaleOptions.options} selected={timeScaleOptions.selected} setter={timeScaleOptions.setter}/>;
    const yAxisChoice = <GraphOption name={yAxisOptions.name} options={yAxisOptions.options} selected={yAxisOptions.selected} setter={yAxisOptions.setter}/>;
    const seasonChoice = <GraphOption name={seasonOptions.name} options={seasonOptions.options} selected={seasonOptions.selected} setter={seasonOptions.setter}/>;

    return (
        <GraphOptionsContent>
            Show me {teamSubsetChoice} teams' {yAxisChoice} by {timeScaleChoice} in the {seasonChoice} season.
        </GraphOptionsContent>
    )
}

export default GraphOptions;
